<template>
  <div class="page" style = "{ height: 100vh }">
    <span class="title">- 这是小程序的世界 -</span>
    <input @keyup.enter="search"  class="inputbox" placeholder="请输入你要查找的小程序" ref="miniAppName" />
    <img v-on:click="search" class="searchIcon" src="../../../assets/images/search.png"/>
    <div class="miniAppList">
      <div class="miniAppItem" v-on:mouseover="showQrcode(item.id)" v-on:mouseout="hideQrcode()"
           v-for="item in miniAppList" :key="item.id" v-on:click="miniAppDetail(item.id)">
        <img class="headPic" :src="item.image"/>
        <span class="miniAppName">{{item.title}}</span>
        <span>{{item.author}}</span>
        <div class="mask">
          <div class="info">
            <img class="infoPic" v-show="qrcode == item.id" :src="item.codeImg"/>
          </div>
        </div>
      </div>
    </div>
    <div class="searchFailTips" v-show="show">
      <h1>抱歉，没有您要查找的小程序哦</h1>
    </div>
    <div class="loading" @click="loadMore" v-show="!allLoaded">
      <img class="loadingPic" src="../../../assets/images/loading.png"/>
    </div>
    <div v-show="allLoaded" class="endTips">
      - end -
    </div>
    <div class="toTopIcon" @click="toTop">
      <img src="../../../assets/images/top.png"/>
    </div>
  </div>
</template>

<script>
// import Base64 from 'js-base64'
let Base64 = require('js-base64').Base64
export default {
  name: 'classifyDetail',
  data () {
    return {
      loading: true, // 设置一个开关来避免重负请求数据
      totalElements: 0, // 初始化信息总条数
      current: 0, // 当前页码
      pageSize: 8, // 每页显示多少条
      allLoaded: false, // 全部加载完毕
      condition: null, // 查询参数，默认为null
      qrcode: false,
      miniAppList: [], // 小程序列表
      show: false,
      height: 0
    }
  },
  methods: {
    // 显示小程序二维码
    showQrcode: function (index) {
      this.qrcode = index
    },
    // 隐藏小程序二维码
    hideQrcode: function () {
      this.qrcode = 0
    },
    toTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    loadMore: function () {
      let that = this
      that.getDatas(++that.current, that.pageSize, that.condition)
    },
    bottomLoadMore: function () {
      let that = this
      let loading = that.loading
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight) {
        if (loading) {
          that.getDatas(++that.current, that.pageSize, that.condition)
        }
      }
    },
    // 搜索小程序
    search () {
      let that = this
      let title = this.$refs.miniAppName.value
      let condition = {}
      condition.where = {}
      if (title) {
        condition.where.title = {}
        condition.where.title.$like = title
      }
      condition.orderBy = {}
      condition.orderBy[1] = 'createTime:desc'
      that.condition = Base64.encode(JSON.stringify(condition))

      let parameter = {}
      parameter.pageNumber = that.pageNumber
      parameter.pageSize = that.pageSize
      parameter.condition = that.condition
      this.$fetch(this.$api.miniapps, parameter)
        .then(function (response) {
          if (that.current + 1 >= response.data.totalPages) {
            that.allLoaded = true
            that.loading = false
          }
          if (response.data.totalElements === 0) {
            that.show = true
          } else {
            that.show = false
          }
          that.miniAppList = response.data.content
        })
    },
    // index跳转查找小程序
    searchMiniapps () {
      let that = this
      let type = this.$route.query.type
      //      let condition = {}
      //      condition.where = {}
      //      if (type) {
      //        condition.where.title = {}
      //        condition.where.title.$like = type
      //      }
      //      condition.orderBy = {}
      //      condition.orderBy[1] = 'createTime:desc'
      //      that.condition = Base64.encode(JSON.stringify(condition))
      let url = this.$api.miniapps
      that.getData(url, that.current, that.pageSize, that.condition, type)
    },
    // 查看小程序详情
    miniAppDetail (id) {
      let that = this
      let miniAppid = id
      that.$router.push({
        name: 'miniAppDetail',
        query: {id: miniAppid}
      })
    },
    getDatas (pageNumber, pageSize, condition) {
      let url = this.$api.miniapps
      let type = -1
      this.getData(url, pageNumber, pageSize, condition, type)
    },
    getData (url, pageNumber, pageSize, condition, type) {
      let that = this
      let parameter = {}
      let resList = []
      parameter.pageNumber = pageNumber
      parameter.pageSize = pageSize
      parameter.condition = condition
      parameter.type = type
      this.$fetch(url, parameter)
        .then(function (response) {
          if (that.current + 1 >= response.data.totalPages) {
            that.allLoaded = true
            that.loading = false
          }
          if (response.data.totalElements === 0) {
            that.show = true
          } else {
            that.show = false
          }
          resList = response.data.content
          that.miniAppList = that.miniAppList.concat(resList)
        })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.bottomLoadMore) //  触发鼠标滚动事件

    //    this.clientHeight = document.documentElement.clientHeight
    //    const that = this
    // 安卓手机键盘吊起挡住输入框

    //    window.onresize = function () {
    //      if (document.documentElement.clientHeight < that.clientHeight) {
    //        // scrollVal为负值
    //        let scrollVal = document.documentElement.clientHeight - that.clientHeight
    //        //        $ ('.searchIcon').css('marginTop', scrollVal)
    //        document.getElementsByClassName('searchIcon').style.marginTop = scrollVal
    //        //        $(".bottom-create").hide();
    //      } else {
    //        //        $ ('.searchIcon').css('marginTop', 0)
    //        document.getElementsByClassName('searchIcon').style.marginTop = 0
    //        //        $(".bottom-create").show();
    //      }
    //    }
  },
  created () {
    this.searchMiniapps()
    //    document.getElementsByTagName('body').height = document.getElementsByTagName('body')[0].clientHeight
    if (/Android [4-6]/.test(navigator.appVersion)) {
      window.addEventListener('resize', function () {
        if (document.activeElement.tagName === 'input') {
          window.setTimeout(function () {
            document.activeElement.scrollIntoViewIfNeeded()
          }, 0)
        }
      })
    }
  }
}
</script>

<style scoped>

  @import '../../../assets/css/miniApp/common.css';
  @import '../../../assets/css/miniApp/classifyDetail.css';
</style>



// WEBPACK FOOTER //
// src/pages/miniapp/classifyDetail/classifyDetail.vue